import { enUS } from 'date-fns/locale'

export const MAX_CHALLENGES = 6
export const DATE_LOCALE = enUS